import { Link } from 'react-router'
import clsx from 'clsx'
import type { ReactNode } from 'react'

type LinkCtaNextProps = {
  ariaLabel?: string
  children: ReactNode
  className?: string
  external?: boolean
  href?: string
  to?: string
}

type LinkCtaNextIconProps = {
  className?: string
}

export const LinkCtaNextIcon = ({ className }: LinkCtaNextIconProps) => (
  <span className={clsx('link-cta-next__icon-wrap', className)}>
    <svg
      aria-hidden="true"
      className="link-cta-next__icon"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        fill="var(--color-brand-primary-next)"
        height="19.2391"
        rx="9.61957"
        width="19.2391"
      />
      <path
        d="M8.28223 6.12598L11.6412 9.48487L8.28223 12.8438"
        stroke="var(--color-text-inverse-next)"
        strokeLinecap="round"
        strokeWidth="1.14258"
      />
    </svg>
  </span>
)

export const LinkCtaNext = ({
  ariaLabel,
  children,
  className,
  external,
  href,
  to,
}: LinkCtaNextProps) => {
  const classes = clsx('link-cta-next', className)

  const icon = <LinkCtaNextIcon />

  const content =
    typeof children === 'string' ? (
      (() => {
        const labelParts = children.match(/^(.*\S)(\s+)(\S+)$/)

        if (!labelParts) {
          return (
            <span className="link-cta-next__tail">
              {children}
              {icon}
            </span>
          )
        }

        const [, leadingText, separator, trailingWord] = labelParts

        return (
          <>
            <span>
              {leadingText}
              {separator}
            </span>
            <span className="link-cta-next__tail">
              {trailingWord}
              {icon}
            </span>
          </>
        )
      })()
    ) : (
      <span className="link-cta-next__tail">
        {children}
        {icon}
      </span>
    )

  if (href) {
    return (
      <a
        aria-label={ariaLabel}
        className={classes}
        href={href}
        rel={external ? 'noopener noreferrer' : undefined}
        target={external ? '_blank' : undefined}
      >
        {content}
      </a>
    )
  }

  return (
    <Link aria-label={ariaLabel} className={classes} to={to ?? '#'}>
      {content}
    </Link>
  )
}
